<template>
  <div style="matgin-bottom: 10px">
    <div class="home-header">
      <img src="https://enited-static-resources.oss-accelerate.aliyuncs.com/static/1521686559603.jpg" />
      <div id="customerChart"></div>
      <div class="mkdir" :class="{ 'before-mkidr': tabbarBoxFixed }"></div>
    </div>

    <div class="home-content">
      <!-- 数字化营销服务 -->
      <div
        class="home-content-title wow  bounceInLeft"
        data-wow-delay="0.2s"
        data-wow-offset="100"
      >
        数智化营销服务
      </div>
      <div class="home-serve">
        <div
          class="serve-left wow bounceInLeft"
          data-wow-delay="0.2s"
          data-wow-offset="100"
        >
          <p class="serve-left-title">我们能做什么?</p>
          <p class="serve-left-content">
            随着数字化和人工智能等技术日新月异的发展，C端消费互联网的日益成熟倒逼B端产业互联网的兴起，作为致力于成为中国领先的商业数智营销服务提供商，天科智友集成业内最先进的技术和资源，赋能B2C和C2C数智营销场景为合作伙伴打造资源对称、信息对称和技术对称的生态产业链。
          </p>
          <div @click="onDetails" class="serve-details">
            <span>详细介绍</span> <span class="serve-jiantou">→</span>
          </div>
        </div>

        <div
          class="serve-right  wow bounceInRight"
          data-wow-delay="0.2s"
          data-wow-offset="100"
        >
          DATA-DRIVEN<br />
          MARKETING
        </div>
      </div>
      <!-- 天津 介绍 -->
      <div class="tj-content">
        <div
          class="tj-left  wow fadeInLeft"
          data-wow-delay="0.2s"
          data-wow-offset="100"
        >
          <p class="tj-left-content">
            <span class="tj-us">我们</span
            >成立于2022年，位于素有“畿辅门户”之称的滨海城市-天津，是一家以数字化和人工智能为抓手的商业数智营销服务提供商
          </p>
          <!-- <div class="serve-details"><span>详细介绍</span> <span class="serve-jiantou">→</span></div> -->
        </div>
        <div
          style="flex: 1"
          class="tj-right  wow fadeInRight"
          data-wow-delay="0.2s"
          data-wow-offset="100"
        >
          <img src="../assets/images/tj.png" mode="scaleToFill" />
        </div>
      </div>
      <!-- 亿来数值 介绍 -->
      <div class="ylsz-content">
        <div
          class="ylsz-left  wow bounceInLeft"
          data-wow-delay="0.2s"
          data-wow-offset="100"
        >
          <img src="../assets/images/ylsz.png" />
        </div>
        <div
          class="ylsz-right  wow bounceInRight"
          data-wow-delay="0.2s"
          data-wow-offset="100"
        >
          <p class="ylsz-left-content">
            <span class="tj-us">亿来数智</span>
            是天科智友推出的集线上线下营销、穿透式供应链管理、电子化认证、电子化业务备案、多元化结算等众多优质服务于一体的新一代数字化营销平台。
          </p>
          <div @click="onIntroduction" class="serve-details">
            <span>详细介绍</span> <span class="serve-jiantou">→</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { inject, ref, onMounted, nextTick } from "vue";
import * as echarts from "echarts";
import { useRouter } from "vue-router";
import { WOW } from "wowjs";

export default {
  name: "Home",
  props: ["tabbarBoxFixed"],
  setup() {
    const router = useRouter();
    onMounted(() => {
      let myChart = echarts.init(document.getElementById("customerChart"));
      var option = {
        graphic: {
          elements: [
            {
              type: "text",
              left: "center",
              top: "center",
              style: {
                font: '0.2rem "pingfang"',
                text: "科 技 助 力 市 场\n\n数 智 成 就 未 来",
                lineDash: [0, 100],
                lineDashOffset: 10,
                fill: "transparent",
                stroke: "#000",
                lineWidth: 0.5,
              },
              keyframeAnimation: {
                duration: 1000,
                loop: false,
                keyframes: [
                  {
                    percent: 0.7,
                    style: {
                      fill: "transparent",
                      lineDashOffset: 200,
                      lineDash: [200, 0],
                    },
                  },
                  {
                    // Stop for a while.
                    percent: 0.8,
                    style: {
                      fill: "transparent",
                    },
                  },
                  {
                    percent: 1,
                    style: {
                      fill: "#2d2d2d",
                    },
                  },
                ],
              },
            },
          ],
        },
      };
      myChart.setOption(option);
      window.onresize = () => {
        myChart.resize();
      };

      // 动画
      nextTick(() => {
        const wow = new WOW({
          live: false,
        });
        wow.init();
      });
    });
    const onDetails = () => {
      router.push("/business");
    };
    const onIntroduction = () => {
      router.push("/introduction");
    };
    return {
      onDetails,
      onIntroduction,
    };
  },
};
</script>
<style scoped lang="scss">
#customerChart {
  width: 2.3rem;
  height: 200px;
  position: absolute;
  left: 10%;
  bottom: 5%;
  z-index: 19;
}
.home-header {
  width: 100%;
  height: 3.8rem;
  background: #f6f6f6;
  position: relative;
  z-index: 1;
  img {
    position: absolute;
    top: 0;
    left: 0;
    height: 3.8rem;
    width: 100%;
    z-index: 11;
  }
  .mkdir {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba($color: #000000, $alpha: 0.5);
    z-index: 20;
    transition: 0.5s;
    opacity: 0;
  }
  .before-mkidr {
    opacity: 1;
    transition: 1s;
  }
}

.home-content {
  height: auto;
  .home-content-title {
    padding: 0.4rem 0 0 0.84rem;
    font-size: 0.3rem;
    font-family: pingfang;
    box-sizing: border-box;
    text-align: left;
    letter-spacing: 0.05rem;
  }
  width: 100%;
  background: #f6f6f6;
  .home-serve {
    width: 100%;
    display: flex;
    height: auto;
    text-align: left;
    .serve-right {
      font-size: 0.5rem;
      color: #00a4a7;
      flex: 1;
      font-family: pingfangB;
    }
    .serve-left {
      font-size: 0.13rem;
      padding: 0.6rem 0.08rem 0 0.84rem;
      box-sizing: border-box;
      .serve-left-content {
        line-height: 0.23rem;
        padding-top: 0.1rem;
        padding-right: 1rem;
        box-sizing: border-box;
      }
    }
    .serve-left-title {
      color: #00a4a7;
    }

    div {
      flex: 1;
    }
  }
}
.serve-details {
  line-height: 30px;
  width: 30%;
  border-bottom: 2px solid;
  border-image-source: linear-gradient(to right, #0088c0, #41b8a2);
  border-image-slice: 2;
  margin-top: 0.6rem;
  font-size: 0.1rem;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  .serve-jiantou {
    font-family: pingfangB;
    font-size: 0.15rem;
    padding-right: 0.2rem;
    box-sizing: border-box;
  }
}
.tj-content {
  width: 100%;
  display: flex;
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;
  height: auto;
  .tj-right {
    text-align: left;
  }
  img {
    flex: 1;
    width: 3rem;
    height: 4rem;
  }
  .tj-left {
    flex: 1;
    text-align: left;
    font-size: 0.13rem;
    padding: 0.6rem 0.08rem 0 0.84rem;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    box-sizing: border-box;
    background: #f4f4f4;

    .tj-left-content {
      line-height: 0.23rem;
      padding-top: 0.1rem;
      padding-right: 1rem;
      box-sizing: border-box;
    }
  }
}

.ylsz-content {
  width: 100%;
  display: flex;
  height: auto;
  padding-bottom: 0.5rem;
  box-sizing: border-box;
  .ylsz-left {
    flex: 1;
    img {
      flex: 1;
      width: 3rem;
      height: 4rem;
    }
  }
  .ylsz-right {
    flex: 1;
    text-align: left;
    font-size: 0.13rem;
    padding: 0.6rem 0.08rem 0 0.84rem;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    box-sizing: border-box;
    .ylsz-left-content {
      line-height: 0.23rem;
      padding-top: 0.1rem;
      padding-right: 1rem;
      box-sizing: border-box;
    }
  }
}
.tj-us {
  color: #00a4a7;
  font-size: 0.24rem;
}
.apply-dialog {
  width: 80%;
  height: 3rem;
  margin: auto;
  background: white;
  display: flex;
}
.applyleft {
  flex: 1;
  display: flex;
}
.applyright {
  flex: 1;
  display: flex;
}
.applyor {
  margin: auto;
  font-size: 0.15rem;
  color: black;
  font-family: pingfangB;
}
.tel {
  color: #2924cf;
  font-size: 0.13rem;
  font-family: pingfang;
}
.tel-num {
  font-size: 0.2rem;
  color: black;
  font-family: pingfangB;
}
.public-form {
  margin-top: 0.2rem;
  .label {
    margin-right: 0.1rem;
    // font-size: 0.08rem;
  }
  .radiomargin {
    margin: 0 0.2rem;
  }
  .inputclass {
    width: 1.3rem;
    height: 25px;
    line-height: 25px;
    border: 1px solid #949bb3;
    border-radius: 5px;
    outline: none;
    color: #2924cf;
    padding-left: 10px;
  }
  input[type="text"]::placeholder {
    color: #c0ccf5;
  }
}
.btn-style {
  padding: 0.08rem 0.12rem !important;
  margin-top: 0.2rem;
  font-size: 0.08rem;
  box-sizing: border-box;
}
</style>
